export enum EXPERIENCE_PLAN_NAME {
  STANDARD = 'standard',
  AUDIO = 'experience_audio_unlimited_monthly',
  SUPER_COACH = 'experience_supercoach_monthly',
  LEGACY_SUPER_COACH = 'super_coach_monthly',
  PREMIUM = 'experience_premium_monthly',
}

export enum EXPERIENCE_PLAN_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELED = 'canceled',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  TRIALING = 'trialing',
  PAUSED = 'paused',
}

export interface ExperiencePlan {
  plan: EXPERIENCE_PLAN_NAME;
  status: EXPERIENCE_PLAN_STATUS;
  isPaidPlan: boolean;
  subscriptionRenewsAt: Date | null;
  trialEnd: Date | null;
  trialStart: Date | null;
  cancelAtPeriodEnd: boolean;
  isBundled: boolean;
  derivedFrom: EXPERIENCE_PLAN_NAME[] | null;
}

export interface SubscribeToExperiencePlanDto {
  /**
   * Subscription plan ID.
   */
  planId: EXPERIENCE_PLAN_NAME;
}
export interface ExperiencePlansResponse {
  success: boolean;
  data: {
    trialAudioUnlimitedUsed?: boolean;
    trialSuperCoachUsed?: boolean;
    plans: ExperiencePlan[];
  };
}
export type SubscribeToExperiencePlanResponse = ExperiencePlansResponse;
export type CancelExperiencePlanResponse = SubscribeToExperiencePlanResponse;

export interface CancelExperiencePlanDto {
  /**
   * Subscription plan ID.
   */
  planId: EXPERIENCE_PLAN_NAME;
}
